import {
  Injectable,
  ComponentRef,
  createComponent,
  EnvironmentInjector,
  ApplicationRef,
} from '@angular/core';
import { SaasTenantDto } from '@volo/abp.ng.saas/proxy';
import { TenantClonePopupComponent } from './tenant-clone-popup/tenant-clone-popup.component';
import { TenantCloneStateService } from './tenant-clone-state.service';

@Injectable({
  providedIn: 'root',
})
export class TenantCustomActionsService {
  private componentRef: ComponentRef<TenantClonePopupComponent> | null = null;

  constructor(
    private cloneStateService: TenantCloneStateService,
    private appRef: ApplicationRef,
    private injector: EnvironmentInjector
  ) {}

  cloneTenant(tenant: SaasTenantDto): void {
    this.cloneStateService.setCloneData(tenant);

    // Dynamically create modal using modern approach
    const componentRef = createComponent(TenantClonePopupComponent, {
      environmentInjector: this.injector,
    });

    componentRef.instance.open = true;

    // Close handler
    componentRef.instance.modalClose.subscribe(() => {
      this.closeModal();
    });

    // Attach to application
    this.appRef.attachView(componentRef.hostView);
    document.body.appendChild((componentRef.hostView as any).rootNodes[0]);

    this.componentRef = componentRef;
  }

  private closeModal(): void {
    if (this.componentRef) {
      this.appRef.detachView(this.componentRef.hostView);
      this.componentRef.destroy();
      this.componentRef = null;
    }
  }
}
